module.exports = __webpack_public_path__ + "94a896cd767c6ac256a2cf1c950015d7.MP3";